export function registerOfflineShell() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

  // Dev: always drop leftover SWs/caches so Vite HMR cannot mix with a stale shell.
  if (!import.meta.env.PROD) {
    void navigator.serviceWorker.getRegistrations().then((regs) => {
      for (const reg of regs) void reg.unregister();
    });
    if ("caches" in window) {
      void caches.keys().then((keys) => {
        for (const key of keys) {
          if (key.startsWith("anga-shell")) void caches.delete(key);
        }
      });
    }
    return;
  }

  void navigator.serviceWorker.register("/sw.js").catch(() => {
    /* ignore */
  });
}
